import React from 'react';

// helpers
import { Button, Icon, Tag } from '@chakra-ui/react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { getAddressView } from 'utils/index';
import { viewDateAndTime } from 'utils/date';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CiEdit } from 'react-icons/ci';
import TabField from 'components/dataDispaly/TabField';

import { viewMobile } from 'utils/number';
import { mapResponseToDefaults } from 'utils/default-util';
import { getAddressString , getStateView } from 'utils/address';

// components
import LoadingDataCard from 'components/Cards/LoadingDataCard';
import LenderForm from 'components/Forms/LenderForm';
import { LENDER_FORM_DEFAULT } from 'constants/index';

export default function ViewLenderPersonal({ isLoading = false , data = {} , refetch }) {
    const history = useHistory();
    const searchparams = new URLSearchParams(history.location.search);
    const isEdit = searchparams.get('isEdit') === 'true';

    const handleEdit = ()=>{
        setisEdit(!isEdit);
    };

    const setisEdit = ()=>{
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('isEdit', !isEdit);

        // history replace
        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    };
    const afterUpdateHandler = ()=>{
        setisEdit(false);
        refetch();
    };

    if (isLoading) {
        return (
            <LoadingDataCard />
        );
    } else {
        return (
            <div>
                <div
                    className="preview-heading"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px',
                        borderBottom: '1px solid #e0e0e0',
                        paddingBottom: '8px'
                    }}
                >
                    <p
                        style={{
                            fontWeight: '600',
                            fontSize: '13px',
                            textTransform: 'uppercase',
                            color: 'black'
                        }}
                    >
                                        General Information
                    </p>
                    <Button onClick={handleEdit} style={{ fontSize: '13px', color: 'teal' }}>
                        {
                            isEdit
                                ? <>
                                            Cancel
                                </>
                                : <>
                                    <Icon as={CiEdit} w={4} h={4} mr={1} />
                                                    Edit Details

                                </>
                        }
                    </Button>

                </div>
                <div className="preview-body">

                    {
                        (isEdit)
                            ? <LenderForm
                                data={ data}
                                handleCancel={handleEdit}
                                afterUpdateHandler={afterUpdateHandler}
                                refetch={refetch}
                                defaultValues={mapResponseToDefaults(LENDER_FORM_DEFAULT , data) }
                            />
                            : <React.Fragment>

                                <div style={{ lineHeight: '2.5rem' }}>
                                    <p><strong>Email</strong><br />{data?.ContactPointEmailValue}</p>
                                    <p><strong>Phone</strong><br />{viewMobile(data) || 'N/A'}</p>
                                    <p><strong>First Name</strong><br />{data?.FirstName || 'N/A'}</p>
                                    <p><strong>Last Name</strong><br />{data?.LastName || 'N/A'}</p>
                                    <p><strong>Branch Name</strong><br />{data?.branchId?.[0]?.branchName}</p>
                                    <p><strong>User Type</strong><br />{data?.userType}</p>
                                    <p><strong>Role</strong><br />     {data?.roleDetail?.displayName || 'N/A'}</p>
                                    <p><strong>Account Status</strong><br /></p>
                                    {
                                        data?.accountStatus
                                            ? <p className='success-text'>
                                                                                ACTIVE
                                            </p>
                                            : <p className='danger-text'>
                                                                                BLOCK
                                            </p>
                                    }
                                    <p><strong>NMLS</strong><br />{data?.NMLS || 'N/A'}</p>
                                    <p><strong>Onboarding Status</strong><br /></p>
                                    {
                                        data?.indicator === 2
                                            ? <p className='success-text'>Completed</p>
                                            : <p className='danger-text'>In Progress</p>
                                    }
                                    <p><strong>Address</strong><br />{getAddressView(data) || 'N/A'} </p>
                                    <p><strong>Refrer By</strong><br />{getAddressString(data?.Address)}</p>
                                    {
                                        data?.refferedByName &&
                                                data?.refferedByName &&
                                                    data?.refferedBy && <>

                                            <Link href={data?.refferedByName === 'REALTOR' ? ' /organization/user/realtor/' + data?.refferedBy : '/organization/user/lender/user/' + data?.refferedBy} color='brand.500'>
                                                                       View Details
                                            </Link>
                                        </>
                                    }
                                    <p><strong>Last Updated On</strong><br />{viewDateAndTime(data?.updatedAt)}</p>

                                    <div className="preview-box">
                                        <div className="preview-heading space-between-box">
                                                                    State Licenses
                                        </div>

                                        <div className="outline-table">
                                            {
                                                (data && data?.Statelicenses?.length > 0 && data?.Statelicenses?.map((state,index)=>(
                                                    <Tag colorScheme='teal' key={index} m={2} size='md'>{state.label || getStateView(state)}</Tag>
                                                ))) || <TabField value={<p>Doesn&apos;t have any state license</p>}/>
                                            }

                                        </div>
                                    </div>

                                </div>

                            </React.Fragment>

                    }
                </div>

            </div>
        );
    }
}
